"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseCardDescription = void 0;
const rateCardValues = {
    rate: 'X.XX%',
    apr: 'X.XX%',
    pointsPaid: 'XXX',
    pointsPaidDollar: 'X,XXX',
};
exports.baseCardDescription = {
    '30 Year Fixed Conforming': {
        title: '30-Year Fixed',
        modalTitle: '30-Year Fixed Rate Conventional',
        excerpt: 'The most common loan type',
        highlight: 'Most popular',
        ...rateCardValues,
        description: [
            '3% min down payment',
            'Lower payments due to longer term',
        ],
    },
    '30 Year FHA': {
        title: '30-Year FHA',
        modalTitle: '30-Year Fixed Rate FHA',
        excerpt: 'Popular with first-time buyers',
        highlight: 'Lower credit profiles',
        ...rateCardValues,
        description: [
            '3.5% min down payment',
            'Looser credit/debt requirements',
        ],
    },
    '30 Year VA': {
        title: '30-Year VA',
        modalTitle: '30-Year VA',
        excerpt: 'For eligible military, veterans and reserves',
        highlight: 'Eligible military',
        ...rateCardValues,
        description: ['0% down payment', 'No private mortgage insurance'],
    },
    '20 Year Fixed Conforming': {
        title: '20-Year Fixed',
        modalTitle: '20-Year Fixed Rate Conventional',
        excerpt: 'Option to pay off conventional loan faster',
        highlight: 'Save on interest',
        ...rateCardValues,
        description: [
            '5% min down payment',
            'Pay less interest due to shorter term',
        ],
    },
    '15 Year Fixed Conforming': {
        title: '15-Year Fixed',
        modalTitle: '15-Year Fixed Rate Conventional',
        excerpt: 'Great for those who can afford higher payments',
        highlight: 'Faster payoff',
        ...rateCardValues,
        description: [
            '5% min down payment',
            'Pay less interest due to shorter term',
        ],
    },
    '25 Year FHA': {
        title: '25-Year FHA',
        modalTitle: '25-Year Fixed Rate FHA',
        excerpt: '',
        highlight: 'Lower credit profiles',
        ...rateCardValues,
    },
    '20 Year FHA': {
        title: '20-Year FHA',
        modalTitle: '20-Year Fixed Rate FHA',
        excerpt: '',
        highlight: 'Lower credit profiles',
        ...rateCardValues,
    },
    '10 Year Fixed Conforming': {
        title: '10-Year Fixed',
        modalTitle: '10-Year Fixed Rate Conventional',
        excerpt: '',
        highlight: 'Faster payoff',
        ...rateCardValues,
    },
    '30 Year Jumbo (Non Conforming)': {
        title: '30-Year Jumbo',
        modalTitle: '30-Year Jumbo',
        excerpt: '',
        highlight: 'Large loan amounts',
        ...rateCardValues,
    },
    '7/6 ARM Conforming': {
        title: '7/6 ARM',
        modalTitle: '7/6 Adjustable Rate Mortgage',
        excerpt: '',
        highlight: 'Save on interest',
        ...rateCardValues,
    },
};
